module.exports = new __parcel__URL__("personal-settings-notifications-app-skeleton-with-projects.tpl.d18b3c58.svg").toString();